import { environment as defaultEnvironment } from './environment.default';

export const environment = {
    ...defaultEnvironment,
}
